import useContent from "@@hooks/useContent";
import useDamageRecognition from "@@pages/item-details/hooks/useDamageRecognitionContext";
import { IEditDamage } from "@@pages/item-details/schemas/ItemDamageSchema";
import getDamageScore from "@@utils/getDamageScore";
import { LayoutMervin, TableCell, TableRow, Typography } from "@lux/ds";
import { useCallback } from "react";
import { Controller } from "react-hook-form";
import { EDamage, EDamageLocation, genericKeys } from "types/damages";
import pascalize from "utils/pascalize";
import DamageSeverityTicker from "./DamageSeverityTicker/DamageSeverityTicker";

const GenericDamage: React.FC = () => {
  const {
    content: { itemReview: content },
  } = useContent();
  const { damageCounts, damageMatrix, form } = useDamageRecognition();

  const handleSeverityChange = useCallback(
    (
      newValue: number | null,
      key: string,
      value: IEditDamage,
      onChange: (value: IEditDamage) => void,
    ) => {
      const damageId =
        key === "others"
          ? EDamage.OtherSmell
          : Number(EDamage[pascalize(key) as unknown as number]);
      const score = getDamageScore(damageMatrix, {
        id: damageId,
        locationId: Number(
          EDamageLocation[pascalize("smell") as unknown as EDamageLocation],
        ),
        severity: newValue as number,
      });
      onChange({
        ...value,
        id: damageId,
        score: score,
        severityId: newValue,
      });
    },
    [damageMatrix],
  );

  return (
    <TableRow>
      <TableCell component='th' scope='row' width={174}>
        <Typography variant='bodyTextSmall'>
          {content.damageLocation.smell}
        </Typography>
        <Typography variant='caption' sx={{ color: "#6A626A" }}>
          {content.damageCategory.damages}: {damageCounts.smell ?? 0}
        </Typography>
      </TableCell>
      <TableCell colSpan={2}>
        <LayoutMervin gap='xs'>
          {genericKeys.map((key, index) => {
            return (
              <Controller
                control={form.control}
                key={index}
                name={`smell.${key}`}
                render={({ field: { onChange, value, ...field } }) => {
                  return (
                    <DamageSeverityTicker
                      {...field}
                      isDisabled={false}
                      label={content.damage[key]}
                      onChangeSeverity={(newValue) =>
                        handleSeverityChange(newValue, key, value, onChange)
                      }
                      value={value?.severityId ?? null}
                    />
                  );
                }}
              />
            );
          })}
        </LayoutMervin>
      </TableCell>
    </TableRow>
  );
};

export default GenericDamage;
